import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import {HashRouter, Route, Switch} from 'react-router-dom';
import 'react-big-calendar/lib/css/react-big-calendar.css'
import 'react-checkbox-tree/lib/react-checkbox-tree.css'
import {
    clearCallbackUrl,
    clearErrorUrl,
    getCodeFromUrl,
    getCodeVerifierFromState,
    getErrorFromUrl,
    getUiOriginFromState,
    keycloakCheckSso,
    keycloakLogin
} from './keycloak';
import {AUTH_MODE, clearAuthSession, getAuthMode, setAuthMode} from './auth/authStorage';
import {exchangeKeycloakCode} from './api/keycloak-token-exchange';
import AuthCallback from "./AuthCallback";

const renderApp = () => {
    ReactDOM.render(
        <HashRouter>
            <Switch>
                <Route path="/auth/callback" component={AuthCallback} noLayout={true}/>
                <Route path="/" component={App}/>
            </Switch>
        </HashRouter>,
        document.getElementById('root')
    );
};

const code = getCodeFromUrl();
const error = getErrorFromUrl();

if (code) {
    const codeVerifier = getCodeVerifierFromState();
    console.log('[SSO] codeVerifier from state:', codeVerifier ? 'found' : 'NOT found (external SSO)');

    if (codeVerifier) {
        console.log('[SSO] Sending authorization code to backend...');
        exchangeKeycloakCode({code, codeVerifier, uiOrigin: getUiOriginFromState() || window.location.origin})
            .then(() => {
                clearCallbackUrl();
                setAuthMode(AUTH_MODE.SSO);
                sessionStorage.setItem('sso_synced', 'true');
                window.location.hash = '#/';
            })
            .catch((err) => {
                sessionStorage.setItem('sso_error', err.message || 'SSO login failed');
                clearAuthSession();
                clearCallbackUrl();
            })
            .finally(() => {
                renderApp();
            });
    } else {
        clearCallbackUrl();
        keycloakLogin();
    }
} else if (error) {
    clearAuthSession();
    clearErrorUrl();
    renderApp();
} else if (getAuthMode() === AUTH_MODE.SSO) {
    keycloakCheckSso();
} else if (!localStorage.getItem('token')) {
    keycloakCheckSso();
} else {
    renderApp();
}

serviceWorker.unregister();
